import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import QuoteModal from "../home/components/QuoteModal";
import WaveDivider from "../home/components/WaveDivider";
import { locationPages } from "../../mocks/locationData";

const locationImages: Record<string, string> = {
  "birmingham-rubbish-removal": "https://readdy.ai/api/search-image?query=vibrant%20crisp%20cartoon%20illustration%20of%20the%20Birmingham%20city%20centre%20skyline%20with%20the%20iconic%20Bullring%20Selfridges%20building%20and%20modern%20canal%20quarter%20on%20a%20sunny%20day%2C%20bold%20vivid%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20warm%20amber%20and%20lime%20green%20tones%2C%20storybook%20illustration%2C%20no%20text%20no%20people&width=600&height=400&seq=loc-idx-bham-cart-v26&orientation=landscape",
  "solihull-rubbish-removal": "https://readdy.ai/api/search-image?query=vibrant%20crisp%20cartoon%20illustration%20of%20Solihull%20town%20centre%20high%20street%20with%20Georgian%20architecture%20lush%20green%20trees%20and%20neat%20British%20shopfronts%20on%20a%20sunny%20afternoon%2C%20bold%20vivid%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20warm%20golden%20and%20lime%20green%20tones%2C%20storybook%20illustration%2C%20no%20text%20no%20people&width=600&height=400&seq=loc-idx-solihull-cart-v26&orientation=landscape",
  "droitwich-spa-rubbish-removal": "https://readdy.ai/api/search-image?query=vibrant%20crisp%20cartoon%20illustration%20of%20Droitwich%20Spa%20canal%20with%20charming%20historic%20buildings%20reflected%20in%20calm%20blue%20water%20and%20green%20Worcestershire%20countryside%20on%20a%20sunny%20day%2C%20bold%20vivid%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20warm%20cheerful%20colours%2C%20storybook%20illustration%2C%20no%20text%20no%20people&width=600&height=400&seq=loc-idx-droitwich-cart-v26&orientation=landscape",
  "bromsgrove-rubbish-removal": "https://readdy.ai/api/search-image?query=vibrant%20crisp%20cartoon%20illustration%20of%20Bromsgrove%20market%20town%20high%20street%20with%20traditional%20British%20buildings%20and%20rolling%20green%20Worcestershire%20hills%20visible%20in%20the%20background%20on%20a%20sunny%20afternoon%2C%20bold%20vivid%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20warm%20golden%20tones%2C%20storybook%20illustration%2C%20no%20text%20no%20people&width=600&height=400&seq=loc-idx-bromsgrove-cart-v26&orientation=landscape",
  "redditch-rubbish-removal": "https://readdy.ai/api/search-image?query=vibrant%20crisp%20cartoon%20illustration%20of%20Arrow%20Valley%20Park%20in%20Redditch%20with%20a%20bright%20blue%20lake%20green%20parkland%20and%20cheerful%20trees%20on%20a%20sunny%20day%2C%20bold%20vivid%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20vivid%20greens%20and%20blues%2C%20lime%20green%20accents%2C%20storybook%20illustration%2C%20no%20text%20no%20people&width=600&height=400&seq=loc-idx-redditch-cart-v26&orientation=landscape",
};

export default function LocationsIndexPage() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <main className="font-sans bg-white">
      <Navbar onBookNow={() => setModalOpen(true)} />

      {/* Hero */}
      <div className="relative">
        <section className="relative w-full min-h-[55vh] overflow-hidden flex flex-col bg-cl-dark">
          <img
            src="https://readdy.ai/api/search-image?query=vibrant%20crisp%20cartoon%20illustration%20of%20the%20English%20West%20Midlands%20countryside%20and%20urban%20landscape%20showing%20patchwork%20green%20fields%2C%20red%20brick%20towns%20and%20motorways%20converging%2C%20dramatic%20overcast%20sky%20with%20diffused%20sunlight%2C%20muted%20natural%20greens%20and%20warm%20brick%20tones%2C%20no%20text%2C%20aerial%20landscape%20photography&width=1600&height=700&seq=loc-idx-hero-cart-v26&orientation=landscape"
            alt="Cleario locations across the UK"
            className="absolute inset-0 w-full h-full object-cover object-center opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-cl-dark/80 via-cl-dark/70 to-cl-dark/90" />
          <div className="relative flex-1 flex flex-col items-center justify-center max-w-screen-xl mx-auto px-6 lg:px-10 w-full pt-36 pb-16 text-center">
            <div className="inline-flex items-center gap-2 text-xs font-black px-4 py-1.5 rounded-full border-2 border-cl-lime text-cl-lime mb-6">
              <i className="ri-map-pin-2-fill text-xs"></i>
              West Midlands Coverage
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-white leading-tight mb-4">
              Rubbish Removal <span className="text-cl-lime">Near You</span>
            </h1>
            <p className="text-white/60 text-lg font-semibold max-w-xl mb-8">
              Cleario operates across the West Midlands — same-day collection, fixed pricing, fully licensed. Serving Solihull, Birmingham, Droitwich Spa, Bromsgrove, Redditch and surrounding areas.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => setModalOpen(true)}
                className="bg-cl-green text-white font-black px-8 py-4 rounded-xl text-sm cartoon-btn-green whitespace-nowrap"
              >
                Book Collection Now
              </button>
              <a
                href="tel:03335775445"
                className="flex items-center justify-center gap-2 bg-white/10 border-2 border-white/25 text-white font-black px-7 py-4 rounded-xl text-sm cartoon-btn whitespace-nowrap"
              >
                <i className="ri-phone-fill text-cl-lime"></i>
                03335 775445
              </a>
            </div>
          </div>
        </section>
        <WaveDivider fromColor="#09245b" toColor="#e8f0fc" />
      </div>

      {/* Locations grid */}
      <section className="bg-cl-tint py-20 px-6 lg:px-10">
        <div className="max-w-screen-xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs font-black text-cl-green uppercase tracking-widest mb-2">Browse by Area</p>
            <h2 className="text-3xl md:text-4xl font-black text-cl-dark">Choose Your Area</h2>
            <p className="text-gray-500 font-semibold mt-3">Click your area to see local services, pricing and availability</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {locationPages.map((loc) => (
              <Link
                key={loc.slug}
                to={`/locations/${loc.slug}`}
                className="group bg-white rounded-2xl thick-border cartoon-shadow overflow-hidden hover:-translate-y-1 transition-all duration-200 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={locationImages[loc.slug]}
                    alt={loc.city}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div
                    className="absolute inset-0"
                    style={{ background: loc.heroGradient, opacity: 0.55 }}
                  />
                  <div className="absolute bottom-3 left-4 right-4 flex items-end justify-between">
                    <div>
                      <p className="text-white font-black text-xl leading-none">{loc.city}</p>
                      <p className="text-white/70 text-xs font-semibold mt-0.5">{loc.county}</p>
                    </div>
                    <div
                      className="w-8 h-8 flex items-center justify-center rounded-lg border-2 border-white/40 bg-white/20"
                      style={{ color: loc.accentHex }}
                    >
                      <i className="ri-arrow-right-up-line text-sm"></i>
                    </div>
                  </div>
                </div>
                <div className="p-5">
                  <p className="text-cl-dark font-black text-sm mb-1">{loc.tagline}</p>
                  <p className="text-gray-500 text-xs font-semibold mb-3">{loc.subheadline}</p>
                  <div className="flex flex-wrap gap-1.5">
                    {loc.areasServed.slice(0, 4).map((area) => (
                      <span key={area} className="bg-cl-tint text-cl-dark text-xs font-bold px-2.5 py-1 rounded-full border border-cl-green">
                        {area}
                      </span>
                    ))}
                    <span className="bg-cl-lime text-cl-dark text-xs font-black px-2.5 py-1 rounded-full border border-cl-green">
                      +{loc.areasServed.length - 4} more
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Not seeing your city */}
      <section className="bg-white py-16 px-6 lg:px-10">
        <div className="max-w-screen-xl mx-auto">
          <div className="bg-cl-dark rounded-2xl p-8 md:p-12 thick-border cartoon-shadow flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="text-white font-black text-2xl mb-2">Don&apos;t see your area?</h3>
              <p className="text-white/60 font-semibold max-w-lg">
                We cover multiple regions using our own fleet and directly employed staff. Contact us if your area isn&apos;t listed and we&apos;ll check availability for you.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
              <a
                href="tel:03335775445"
                className="flex items-center justify-center gap-2 bg-cl-lime text-cl-dark font-black px-7 py-3.5 rounded-xl text-sm cartoon-btn whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i>
                03335 775445
              </a>
              <button
                onClick={() => setModalOpen(true)}
                className="bg-cl-green text-white font-black px-7 py-3.5 rounded-xl text-sm cartoon-btn-green whitespace-nowrap"
              >
                Book Online
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <QuoteModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </main>
  );
}
